<script>
export let hidden;
export let closeFn;
</script>



<div class="dialog" hidden={hidden}>
  <div class="dialog-overlay" on:click={closeFn} />
  <slot />
</div>



<style>
.dialog {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: fit-content;
  height: fit-content;
  margin: auto;
  z-index: 2;
}

.dialog-overlay {
  content: '';
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: -1;
  background-color: var(--dialog-overlay);
  backdrop-filter: blur(3px);
  cursor: move;
}
</style>
